export default angular.module('ApiUtils.fms', [
        'ApiUtils.fms.cropProgress',
        'ApiUtils.fms.fieldplotcrop',
        'ApiUtils.fms.farmfield'
    ]);
